import React from 'react'

import Modal from 'components/Modal'
import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

import Brand from 'helpers/brand'

import { ButtonContainer } from 'styles/shared'

type CantRestoreModalProps = {
  closeCallback: () => void
  isVisible?: boolean
}

const CantRestoreModal = ({ closeCallback, isVisible = false }: CantRestoreModalProps) => {
  const brandName = Brand.brandName()

  return (
    <Modal
      variant="sm"
      fullWidth={false}
      title={'cannot restore system'}
      isDisplayed={isVisible}
      closeCallback={() => closeCallback()}
    >
      This system cannot be restored because it no longer exists in {brandName} Home.
      <ButtonContainer noBorder>
        <Button decoration="positive" text="Ok" onPress={closeCallback} />
      </ButtonContainer>
    </Modal>
  )
}

export default CantRestoreModal
